import { formatCurrency } from '@/common/common_utils';
import { X4bEmployeeDetailsDto } from '@/modules/people/engine/people.types';
import moment from 'moment';

type Ride = {
	service?: string;
	average?: number;
	total?: string;
	time?: string;
};

type Send = {
	service?: string | null;
	average?: number | null;
	total?: string | null;
	time?: string | null;
};

type Eats = {
	product?: string | null;
	store?: string | null;
	total?: string | null;
	time?: string | null;
};

type Mart = {
	product?: string | null;
	store?: string | null;
	total?: string | null;
	day?: string | null;
};

type Insights = {
	lastLogin: string;
	lastCompletedBooking: string;
	customerTier: string;
	completedOrders: number;
	qrCode: string;
	ride: Ride;
	send: Send;
	eats: Eats;
	mart: Mart;
};

type Props = {
	employee: X4bEmployeeDetailsDto;
};

const Insights = (props: Props) => {

	const emp = props.employee;

	// Helper function to format date as "Today" or formatted date
	const formatDateAsToday = (date: Date | undefined): string => {
		if (!date) return '-';

		const inputDate = moment(date);

		// Check if the date is today
		if (inputDate.isSame(moment(), 'day')) {
			return 'Today';
		}

		// Format the date (MMM D, YYYY format)
		return inputDate.format('MMM D, YYYY');
	};

	const infoItemTemplate = (label: string, value: string | number) => (
		<div className="flex justify-between py-2 items-center">
			<span className="text-label-small text-black">{label}</span>
			<span className="text-label-small text-neutral40">{value}</span>
		</div>
	);

	const headerTemplate = (image: string, label: string) => (
		<div className="flex gap-4 items-center">
			<img src={image} alt="icon" width={52} height={52} />
			<h1 className="text-label-large font-semibold">{label}</h1>
		</div>
	);

	const rideCard = (
		<div className='w-full'>
			{headerTemplate('/images/svg/Service Icons.svg', 'Ride')}
			{infoItemTemplate(
				'Most Used Service',
				props.employee.MostUsedService ?? '-',
			)}
			{infoItemTemplate(
				'Avg Booking per week',
				props.employee.AvgBookingPerWeek ?? '-',
			)}
			{infoItemTemplate('Total Spend', formatCurrency(emp.TotalSpend ?? 0))}
			{infoItemTemplate('Usual Booking Time', emp.UsualBookingTime ?? '-')}
		</div>
	);

	// const sendCard = (
	// 	<div>
	// 		{headerTemplate('/images/svg/box.svg', 'Send')}
	// 		{infoItemTemplate(
	// 			'Most Used Service',
	// 			insights.send.service ?? '-',
	// 		)}
	// 		{infoItemTemplate(
	// 			'Avg Booking per week',
	// 			insights.send.average ?? '-',
	// 		)}
	// 		{infoItemTemplate('Total Spend', insights.send.total ?? '₱0.00')}
	// 		{infoItemTemplate('Usual Booking Time', insights.send.time ?? '-')}
	// 	</div>
	// );

	// const eatsCard = (
	// 	<div>
	// 		{headerTemplate('/images/svg/eats.svg', 'Eats')}
	// 		{infoItemTemplate(
	// 			'Most Ordered Product',
	// 			insights.eats.product ?? '-',
	// 		)}
	// 		{infoItemTemplate('Most Popular Store', insights.eats.store ?? '-')}
	// 		{infoItemTemplate('Total Spend', insights.eats.total ?? '₱0.00')}
	// 		{infoItemTemplate('Usual Booking Time', insights.eats.time ?? '-')}
	// 	</div>
	// );

	// const martCard = (
	// 	<div>
	// 		{headerTemplate('/images/svg/mart.svg', 'Mart')}
	// 		{infoItemTemplate(
	// 			'Most Ordered Product',
	// 			insights.mart.product ?? '-',
	// 		)}
	// 		{infoItemTemplate('Most Popular Store', insights.mart.store ?? '-')}
	// 		{infoItemTemplate('Total Spend', insights.mart.total ?? '₱0.00')}
	// 		{infoItemTemplate('Normal Shopping Day', insights.mart.day ?? '-')}
	// 	</div>
	// );

	return (
		<div className="space-y-6">
			{/* Overview Section */}
			<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
				<div className="p-4 bg-surfaceContainerLow rounded-[18px] content-center">
					{infoItemTemplate('Last Login', formatDateAsToday(emp.LastLoginTime))}
					<div className="flex justify-between py-2 items-center">
						<span className="text-label-small">
							Last Completed Booking
						</span>
						<span className="text-label-small text-tertiary underline">
							{formatDateAsToday(emp.LastCompletedBooking)}
						</span>
					</div>
					{/* {infoItemTemplate(
					'Customer Tier',
					insights.customerTier ?? '-',
				)} */}
					{infoItemTemplate(
						'Completed Orders',
						emp.CompletedOrders ?? '-',
					)}
				</div>

				{/* <div className="p-4 bg-surfaceContainerLow rounded-[18px]">
					<div className="flex justify-between items-center">
						<div>
							<h3 className="text-label-large font-medium">
								Customer QR
							</h3>
							<p className="text-label-small text-base text-neutral40">
								X-1234AAA
							</p>
						</div>
						<img
							src={'/images/svg/QR.svg'}
							alt="qr"
							width={128}
							height={137}
						/>
					</div>
				</div> */}
			</div>
			{/* Services Section */}
			<div className="grid grid-cols-1">
				<div className="p-4 bg-surfaceContainerLow rounded-[18px]  w-1/2">
					<div className="w-full">
						{rideCard}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Insights;
